import { render } from "./ContatoGrid.vue?vue&type=template&id=66de96f5&scoped=true"
import script from "./ContatoGrid.vue?vue&type=script&lang=js"
export * from "./ContatoGrid.vue?vue&type=script&lang=js"

import "./ContatoGrid.vue?vue&type=style&index=0&id=66de96f5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66de96f5"]])

export default __exports__